<div class="region-restriction-wrapper">
  <!-- Header with image or text -->
  <div class="header">
    <img class="header-image" src="assets/images/media/brand/pubs-logo.png" alt="" />
  </div>

  <!-- Main content -->
  <div class="content">
    <!-- Title -->
    @if (data.title) {
      <div class="title">{{ data.title }}</div>
    }

    <!-- Message -->
    @if (data.message) {
      <div class="message">
        @for (msg of getMessageArray(); track msg) {
          <p class="message-line">{{ msg }}</p>
        }
      </div>
    }
  </div>

  <!-- Buttons -->
  <div class="buttons">
    @if (data.confirmText) {
      <cs-button [label]="data.confirmText" color="primary" size="large" (buttonClick)="onConfirm()"></cs-button>
    }
    @if (data.cancelText) {
      <cs-button [label]="data.cancelText" color="secondary" size="large" (buttonClick)="onCancel()"></cs-button>
    }
  </div>
</div>
